import React, { useEffect, useState } from 'react';
import GenericTemplate from '../components/templates/GenericTemplate';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  IconButton,
} from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Box } from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';
// import { db } from '../common/firebase/firebase';
// import { CL_NGWORDS } from '../common/constants';
import { getNgWords, changeNgWords } from 'src/admin/firebase/ngwords';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 650,
    },
    form: {
      display: 'flex',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  }),
);

// type NGWord = {
//   list: string[];
// };

// const DOC_ID = 'ngwordlist';

const NgWord: React.FC = () => {
  const classes = useStyles();
  const [ngWords, setNgWords] = useState<string[]>([]);
  const [newWord, setNewWord] = useState('');
  const [bulkInput, setBulkInput] = useState('');

  useEffect(() => {
    fetchNgWords();
  }, []);

  const fetchNgWords = async () => {
    const list = await getNgWords();
    if (list) {
      setNgWords(list);
    } else {
      console.error('Failed to fetch NG words');
    }
  };

  const updateNgWords = async (updatedList: string[]) => {
    await changeNgWords(updatedList);
    setNgWords(updatedList);
  };

  const handleAdd = async () => {
    if (!newWord.trim()) return;
    console.log('Adding new NG word:', newWord.trim());
    const updated = [...ngWords, newWord.trim()];
    await updateNgWords(updated);
    setNewWord('');
  };

  const handleDelete = async (word: string) => {
    const updated = ngWords.filter((w) => w !== word);
    await updateNgWords(updated);
  };

  return (
    <GenericTemplate title="NGワード管理">
      <Box mb={2}>
        <Link component={RouterLink} to="/ngwords/checker">
          NGワードチェッカー
        </Link>
      </Box>

      <div className={classes.form}>
        <TextField
          label="カンマ区切り、または改行区切りのデータでNGワードを一括入力"
          value={bulkInput}
          onChange={(e) => setBulkInput(e.target.value)}
          fullWidth
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={async () => {
            const words = Array.from(
              new Set(
                bulkInput
                  .split(/[\r\n,\t]+/) // 改行(CRLF/LF)・カンマ・タブ
                  .map((w) => w.trim())
                  .filter(Boolean),
              ),
            );

            if (words.length === 0) return;

            console.log('一括更新:', words);
            await updateNgWords(words);
            setBulkInput('');
          }}
        >
          一括更新
        </Button>
      </div>

      <div className={classes.form}>
        <TextField
          label="新しいNGワード"
          value={newWord}
          onChange={(e) => setNewWord(e.target.value)}
        />
        <Button variant="contained" color="primary" onClick={handleAdd}>
          追加
        </Button>
      </div>

      <TableContainer component={Paper}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>NGワード</TableCell>
              <TableCell>操作</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ngWords.map((word, index) => (
              <TableRow key={word}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{word}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleDelete(word)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </GenericTemplate>
  );
};

export default NgWord;
